
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage} from "firebase/messaging";

// Configure Firebase.
const firebaseConfig = {
  apiKey: "AIzaSyCLUUV7eiz7czyvMD7u8z0PJFzA6S-MiDE",
  authDomain: "seder-f70f0.firebaseapp.com",
  projectId: "seder-f70f0",
  storageBucket: "seder-f70f0.appspot.com",
  messagingSenderId: "1031502884003",
  appId: "1:1031502884003:web:0ac42df91542e50762a316",
  measurementId: "G-C99TM1K2DJ"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);


export { messaging, getToken, onMessage };


